// Typed client for the Weekly Mock (full timed paper + band estimate).
// Server: student-agent-api/routers/weekly_mock_router.py at /student/weekly-mock.

import api from './api';
import { DrillAnswerResponse, DrillProgress, DrillQuestion } from './aptitudeDrillAPI';

export interface MockTodayResponse {
  session_id: string;
  week: string;
  subject: string;
  status: 'in_progress' | 'completed' | 'abandoned';
  total_questions: number;
  time_limit_min: number;
  time_limit_seconds: number;
  elapsed_seconds: number;
  remaining_seconds: number;
  questions: DrillQuestion[];
  progress: DrillProgress;
}

export interface MockBand {
  band: string;
  label: string;
  score_pct: number;
}

export interface MockCompleteResponse {
  session_id: string;
  week: string;
  subject: string;
  status: string;
  score: number;
  total: number;
  band: MockBand;
  by_topic: Record<string, { answered: number; correct: number }>;
  time_spent_seconds: number;
  time_limit_min: number;
}

export const weeklyMockAPI = {
  today: async (subject?: string): Promise<MockTodayResponse> => {
    const response = await api.get<MockTodayResponse>('/student/weekly-mock/today', {
      params: subject ? { subject } : undefined,
    });
    return response.data;
  },

  answer: async (
    question_id: string,
    selected_answer: string,
    time_spent_seconds: number,
    subject?: string,
  ): Promise<DrillAnswerResponse> => {
    const response = await api.post<DrillAnswerResponse>(
      '/student/weekly-mock/answer',
      { question_id, selected_answer, time_spent_seconds },
      { params: subject ? { subject } : undefined },
    );
    return response.data;
  },

  complete: async (subject?: string): Promise<MockCompleteResponse> => {
    const response = await api.post<MockCompleteResponse>(
      '/student/weekly-mock/complete',
      {},
      { params: subject ? { subject } : undefined },
    );
    return response.data;
  },
};
